module.exports = __webpack_public_path__ + "4bfe33bb215abaf3315c2ee05052e06d.pdf";